<!-- @deprecated This component is deprecated and should not be used -->
<template>
  <!-- Innovadis custom styling and properties prop added -->
  <div v-if="canReadPricing" class="flex flex-col">
    <div class="flex space-x-1">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual)"
        class="block font-extrabold text-[color:var(--color-price-current)]"
        :class="priceColorClass"
        :value="value?.actual"
      />

      <!-- Innovadis custom -->
      <VcPriceDisplay
        v-else
        class="block font-bold text-[color:var(--color-price-current)]"
        :class="priceColorClass"
        :value="value?.list"
      />
      <!-- <span class="block">{{ $t('common.suffixes.per_item') }}</span> -->
    </div>

    <div class="leading-4">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual) && promotionActive"
        class="text-xs font-semibold line-through"
        :value="value?.list"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePricingPermission } from "@/core/composables";
import { shouldUseActualPrice } from "@/ui-kit/utilities/price";
import type { MoneyType, PriceType, Property } from "@/core/api/graphql/types";

interface IProps {
  value?: PriceType | { list: MoneyType; actual: MoneyType };
  priceColorClass?: string;
  properties: Property[] | undefined;
}

const props = withDefaults(defineProps<IProps>(), {
  priceColorClass: "text-[color:var(--color-price)]",
});

// Innovadis custom: hide item price component when the user does not have pricing:read permission.
const { canReadPricing } = usePricingPermission();

const promotionActiveProperty = "promotionactive_property";
const promotionActive = computed<boolean>(
  () => props.properties?.filter((item) => item.name === promotionActiveProperty)[0].value === true,
);
// eslint-disable-next-line no-console
console.warn("[UIKit][warn] VcItemPrice is deprecated and should not be used.");
</script>
